import { ItemCategory } from "./item-category.model";

export class GeneralCategory {
  id: string;
  name: string;
  description: string;
  parentId: string;
  parentName: string;
  items: ItemCategory[];

  public static build(): GeneralCategory {
    const generalCategory = new GeneralCategory();
    generalCategory.id = null;
    generalCategory.name = null;
    generalCategory.description = null;
    generalCategory.parentId = null;
    generalCategory.parentName = null;
    generalCategory.items = null;
    return generalCategory;
  }
}
